import api from './Base';
import { TimeRange } from '../types/TimeRange';
import { buildApiQuery } from '../helpers/timeRangeUtils';
import SensorStatusHistoryEntry from '../types/SensorStatusHistory';
import { showError } from '../utils/showAlert';

export type SensorTargetKind = 'datasource' | 'host';

const fetchSensorStatus = async <T>(
    kind: SensorTargetKind,
    endpoint: 'timeslice' | 'history',
    timeRange: TimeRange,
    label: string,
): Promise<T[]> => {
    const url = `${kind}/status/${endpoint}?${buildApiQuery(timeRange)}`;
    let result: T[] = [];
    await api.get<T[]>(url)
        .then((response) => { result = response.data; })
        .catch((error: any) => {
            console.error(`Failed to retrieve ${label}.`, error);
            showError(`Failed to retrieve ${label}`, error.message || error.toString());
        });
    return result;
};

const SensorStatusApi = {
    getTimeslices: (kind: SensorTargetKind, timeRange: TimeRange): Promise<string[]> =>
        fetchSensorStatus<string>(kind, 'timeslice', timeRange, `${kind} status timeslices`),

    getHistory: (kind: SensorTargetKind, timeRange: TimeRange): Promise<SensorStatusHistoryEntry[]> =>
        fetchSensorStatus<SensorStatusHistoryEntry>(kind, 'history', timeRange, `${kind} status history`),
};

export default SensorStatusApi;
